import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../../util/app";
// import AuthProvider from "../../../providers/Auth.Provider";
import { useQuery, useMutation } from "react-apollo";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../partials/loading";
import { GET_LEAVE_ALL_STAFF, APPROVE_LEAVE, DECLINE_LEAVE, ACCEPT_LEAVE } from "../../../queries/staff-leave.query";
import StaffLeaveItems from "../partials/Leave/Listing";
import Pagination from "../../../partials/pagination";
import { sendNotification } from "../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../event/model";
import { EventEmitter } from "../../../event/EventEmitter";

const StaffLeaveList = ({ id }) => {
    const title = "Manage Annual Leave";

    const [page, setPage] = useState(1);
    const [limit] = useState(25);

    // get list
    const { loading, data, fetchMore, refetch } = useQuery(GET_LEAVE_ALL_STAFF, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        variables: { page, limit },
        notifyOnNetworkStatusChange: true,
    });

    // Approve
    const [approveFunc, { loading: aLoading }] = useMutation(APPROVE_LEAVE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.ApproveStaffLeave;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.STAFF_ANNUAL_LEAVE);
        },
    });

    // Decline
    const [declineFunc, { loading: dLoading }] = useMutation(DECLINE_LEAVE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.DeclineStaffLeave;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.STAFF_ANNUAL_LEAVE);
        },
    });
    // Decline
    const [returnFunc, { loading: rLoading }] = useMutation(ACCEPT_LEAVE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.AcceptLeaveReturn;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.STAFF_ANNUAL_LEAVE);
        },
    });

    // const { id: ref } = AuthProvider.authProvider.GetAuthenticatedStaff();

    useEffect(() => {
        fetchMore({
            variables: { page },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return {
                    GetAllStaffLeaveList: fetchMoreResult.GetAllStaffLeaveList,
                };
            },
        });
    }, [fetchMore, page]);

    EventEmitter.subscribe(EVENT_TARGET.STAFF_ANNUAL_LEAVE, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-head">
                            <header>{title}</header>
                            <div className="float-right">
                                <button onClick={() => window.print()} className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored">
                                    <i className="material-icons text-white">print</i>
                                </button>
                            </div>
                        </div>
                        <div className="card-body" style={{ minHeight: "520px" }}>
                            <LoadingSpinner loading={loading || dLoading || aLoading || rLoading} />
                            {data && (
                                <StaffLeaveItems
                                    onDecline={async (item) => {
                                        const note = window.prompt("Enter decline note: (optional)");
                                        await declineFunc({ variables: { id: item.id, note } });
                                    }}
                                    onApprove={async (item) => {
                                        const note = window.prompt("Enter approval note: (optional)");
                                        await approveFunc({ variables: { id: item.id, note } });
                                    }}
                                    onReturn={async (item) => {
                                        const note = window.prompt("Enter leave return note: (optional)");
                                        await returnFunc({ variables: { id: item.id, note } });
                                    }}
                                    items={data.GetAllStaffLeaveList.docs}
                                />
                            )}
                        </div>
                        <div className="card-footer">
                            {data && (
                                <Pagination
                                    length={data.GetAllStaffLeaveList.docs.length}
                                    {...data.GetAllStaffLeaveList}
                                    onPageClicked={(page) => {
                                        setPage(page);
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StaffLeaveList;
